import {
    MediaPlayRequestEvent,
    MediaSeekingRequestEvent,
    Slider,
    SliderDragEndEvent,
    SliderDragStartEvent,
    TimeSlider,
    TimeSliderInstance,
} from '@vidstack/react';
import { forwardRef } from 'react';
import { React } from 'Imports';

interface VideoTimeSliderControlProps {
    pauseWhileDragging?: boolean;
    seekingRequestThrottle?: number;
    onDragStart?: (detail: number, nativeEvent: SliderDragStartEvent) => void;
    onDragEnd?: (detail: number, nativeEvent: SliderDragEndEvent) => void;
    onMediaSeekingRequest?: (detail: number, nativeEvent: MediaSeekingRequestEvent) => void;
    onMediaPlayRequest?: (nativeEvent: MediaPlayRequestEvent) => void;
}

const styles = require('../VideoPlayer.scss') as {
    mediaSlider: string;
    mediaSliderTrack: string;
    mediaSliderTrackFill: string;
    sliderPreview: string;
    sliderValue: string;
    mediaSliderThumb: string;
};

const VideoTimeSliderControl = forwardRef<TimeSliderInstance, VideoTimeSliderControlProps>((props, ref) => {
    return (
        <TimeSlider.Root
            className={styles.mediaSlider}
            pauseWhileDragging={props.pauseWhileDragging ?? true}
            ref={ref}
            seekingRequestThrottle={props.seekingRequestThrottle ?? 50}
            onMediaSeekingRequest={props.onMediaSeekingRequest}
            onDragStart={props.onDragStart}
            onDragEnd={props.onDragEnd}
            onMediaPlayRequest={props.onMediaPlayRequest}
        >
            <TimeSlider.Track className={styles.mediaSliderTrack}>
                <Slider.TrackFill className={`${styles.mediaSliderTrackFill} ${styles.mediaSliderTrack}`} />
            </TimeSlider.Track>

            <Slider.Preview className={styles.sliderPreview}>
                <Slider.Value className={styles.sliderValue} />
            </Slider.Preview>

            <Slider.Thumb className={styles.mediaSliderThumb} />
        </TimeSlider.Root>
    );
});

VideoTimeSliderControl.displayName = 'VideoTimeSliderControl';

export default VideoTimeSliderControl;
